import { useEffect } from 'react';

const GTMLoader = ({ gtmId, defaultConsentSet }) => {
    const gaMeasurementId = "G-DD857P1T1L";

    useEffect(() => {
        const loadGTM = () => {
            if (window.gtmInitialized) return;
            window.gtmInitialized = true;

            // // Controlla se il consenso predefinito è stato configurato
            // if (!defaultConsentSet) {
            //     console.warn('Default consent non impostato. Google Tag Manager non verrà caricato.');
            //     return;
            // }

            // Carica lo script di GTM
            const gtmScript = document.createElement('script');
            gtmScript.async = true;
            gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
            gtmScript.setAttribute('data-cookieconsent', 'ignore');
            document.body.appendChild(gtmScript);

            // Aggiunge il noscript
            const noscript = document.createElement('noscript');
            const iframe = document.createElement('iframe');
            iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
            iframe.height = "0";
            iframe.width = "0";
            iframe.style.display = "none";
            iframe.style.visibility = "hidden";
            iframe.setAttribute('data-cookieconsent', 'ignore');
            noscript.appendChild(iframe);
            document.body.insertBefore(noscript, document.body.firstChild);
        };

        loadGTM();

        // // Inizializza Google Analytics 4 con Consent Mode v2
        // (function () {
        //     // Carica manualmente GA4
        //     const gaScript = document.createElement("script");
        //     gaScript.async = true;
        //     gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`;
        //     document.head.appendChild(gaScript);

        //     // Inizializza gtag e configura il Consent Mode v2
        //     window.dataLayer = window.dataLayer || [];
        //     function gtag() { window.dataLayer.push(arguments); }
        //     window.gtag = gtag;

        //     // Configura GA4
        //     gtag("js", new Date());
        //     gtag("config", gaMeasurementId, { anonymize_ip: true });
        // })();

    }, [gtmId]);

    return null;
};

export default GTMLoader;
